import { useEffect, useState } from "react";
import AdminShell from "@/components/AdminShell";
import api from "@/lib/api";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, LineChart, Line, PieChart, Pie, Cell, CartesianGrid } from "recharts";

const COLORS = ["#D96B27", "#0F172A", "#475569", "#059669", "#D97706", "#2563EB", "#7C3AED", "#DB2777", "#0891B2", "#65A30D"];

const Panel = ({ title, children }) => (
  <div className="bg-white rounded-xl border border-slate-200 p-5">
    <h3 className="font-display font-semibold text-slate-900 mb-4">{title}</h3>
    <div style={{ height: 260, minWidth: 0 }}>{children}</div>
  </div>
);

export default function AdminAnalytics() {
  const [a, setA] = useState(null);
  useEffect(() => { api.get("/admin/analytics").then((r) => setA(r.data)).catch(() => {}); }, []);
  if (!a) return <AdminShell><div className="h-96 bg-white rounded-xl animate-pulse" /></AdminShell>;

  return (
    <AdminShell>
      <h1 className="font-display text-2xl font-bold text-slate-900 mb-5">Analytics & Reports</h1>
      <div className="grid lg:grid-cols-2 gap-4">
        <Panel title="Candidate Registrations by Month">
          <ResponsiveContainer><LineChart data={a.candidates_by_month}><CartesianGrid strokeDasharray="3 3" stroke="#f1f5f9" /><XAxis dataKey="month" fontSize={11} /><YAxis fontSize={11} /><Tooltip /><Line type="monotone" dataKey="value" stroke="#D96B27" strokeWidth={2} /></LineChart></ResponsiveContainer>
        </Panel>
        <Panel title="Experience Distribution">
          <ResponsiveContainer><BarChart data={a.experience_distribution}><CartesianGrid strokeDasharray="3 3" stroke="#f1f5f9" /><XAxis dataKey="name" fontSize={11} /><YAxis fontSize={11} /><Tooltip /><Bar dataKey="value" fill="#0F172A" radius={[4, 4, 0, 0]} /></BarChart></ResponsiveContainer>
        </Panel>
        <Panel title="Top Candidate Skills">
          <ResponsiveContainer><BarChart layout="vertical" data={a.top_skills.slice(0, 8)}><XAxis type="number" fontSize={11} /><YAxis type="category" dataKey="name" fontSize={10} width={90} /><Tooltip /><Bar dataKey="value" fill="#D96B27" radius={[0, 4, 4, 0]} /></BarChart></ResponsiveContainer>
        </Panel>
        <Panel title="Most Demanded Products">
          <ResponsiveContainer><BarChart layout="vertical" data={a.top_products.slice(0, 8)}><XAxis type="number" fontSize={11} /><YAxis type="category" dataKey="name" fontSize={10} width={90} /><Tooltip /><Bar dataKey="value" fill="#475569" radius={[0, 4, 4, 0]} /></BarChart></ResponsiveContainer>
        </Panel>
        <Panel title="Education Distribution">
          <ResponsiveContainer><PieChart><Pie data={a.education_distribution} dataKey="value" nameKey="name" cx="50%" cy="50%" outerRadius={90} label>{a.education_distribution.map((e, i) => <Cell key={i} fill={COLORS[i % COLORS.length]} />)}</Pie><Tooltip /></PieChart></ResponsiveContainer>
        </Panel>
        <Panel title="Top Locations">
          <ResponsiveContainer><BarChart data={a.top_locations.slice(0, 8)}><CartesianGrid strokeDasharray="3 3" stroke="#f1f5f9" /><XAxis dataKey="name" fontSize={10} /><YAxis fontSize={11} /><Tooltip /><Bar dataKey="value" fill="#059669" radius={[4, 4, 0, 0]} /></BarChart></ResponsiveContainer>
        </Panel>
        <Panel title="Top Technical Processes">
          <ResponsiveContainer><BarChart layout="vertical" data={a.top_processes.slice(0, 8)}><XAxis type="number" fontSize={11} /><YAxis type="category" dataKey="name" fontSize={10} width={100} /><Tooltip /><Bar dataKey="value" fill="#2563EB" radius={[0, 4, 4, 0]} /></BarChart></ResponsiveContainer>
        </Panel>
        <Panel title="Top Departments">
          <ResponsiveContainer><BarChart data={a.top_departments.slice(0, 8)}><CartesianGrid strokeDasharray="3 3" stroke="#f1f5f9" /><XAxis dataKey="name" fontSize={9} /><YAxis fontSize={11} /><Tooltip /><Bar dataKey="value" fill="#D97706" radius={[4, 4, 0, 0]} /></BarChart></ResponsiveContainer>
        </Panel>
      </div>
    </AdminShell>
  );
}
